import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App } from 'antd'
import { useSelector } from 'react-redux'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import { updateAccountBudgets } from '../service/accountService'
import { AccountMonthlyBudget } from '../types/AccountMonthlyBudget'
import accountQueryKeys from './accountQueryKeys'
import { filtersSelector } from '../../../redux/context/filters/selectors'
import { showSuccessMessage } from '../../../utils/message'

export const useUpdateAccountBudgets = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const { budgetingScenario, dimensionsQuery } = useSelector(filtersSelector)
  const { notification } = App.useApp()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['budget', 'accountBudgets'],
    mutationFn: (data: AccountMonthlyBudget[]) => {
      if (!companyId) {
        return Promise.reject(new Error('Company ID is required for account budgets.'))
      }
      return updateAccountBudgets(data, companyId, budgetingScenario?.id, dimensionsQuery)
    },
    onSuccess() {
      // Note: Financial statements invalidation is handled by global mutation observer
      // in src/services/api/queryClient.ts
      showSuccessMessage()
    },
    onError(error) {
      notification.error({ message: error.message })
    }
  })
}
